var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
// 公共 store 参数存放
import Vue from 'vue';
import Vuex from 'vuex';
import common from './common'; // 公共store
Vue.use(Vuex);
var pageList = process.env.PAGE_LIST;
var storeMap = {};
if (pageList && pageList.length) {
    pageList.forEach(function (page) {
        var relativePath = page.relativePath.split('/pages/');
        var currentStoreConfig = require("../views/" + relativePath[0] + "/store/index.ts").default;
        storeMap[relativePath[0]] = currentStoreConfig;
    });
}
export default new Vuex.Store({
    modules: __assign({ common: common }, storeMap)
});
